import React from 'react';
import './ServiceStripe.scss';
import { Link } from 'react-router-dom';
import { getEnabledServices } from '../../config/services';

const ServiceStripe = () => {
    const enabledServices = getEnabledServices();

    return (
        <div className="our-services" id="our-service-section">
            <div className="our-services-content">
                <h2>Our AI & Machine Learning Services</h2>
                <p className="our-services-content-p">
                    From concept to deployment, we deliver enterprise AI solutions powered by Large Language Models, RAG systems, and Computer Vision. Our expert team handles everything from custom model development and intelligent automation to production-ready MLOps infrastructure.
                </p>
                <div className="service-cards">
                    {enabledServices.map((service, index) => (
                        <div 
                            key={service.id} 
                            className="service-card"
                            style={{ '--card-index': index }}
                        >
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                            <Link to={service.path} className="learn-more">
                                Learn More
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceStripe;


